export const steps = [
  {
    title: 'Basic info',
    description:
      'Create your account with some basic information — name, contact info, and some context about your experience with mental health care.'
  },
  {
    title: 'Choose a service',
    description:
      'Learn a bit more about therapy and medication and then choose the right service to support you. You can add or switch services later for any reason.'
  },
  {
    title: 'Choose a clinician + book a session',
    description:
      'See all available clinicians in your area and filter by age, gender, experience, and more. You can read their bios, see their availability, and book your first session. '
  }
];
